export const theme = {
  purple: '#7600d9',
  lavender: '#bfa3f0',
  black: '#221e20',
  background: '#f2f2f2'
}



// WEBPACK FOOTER //
// ./src/assets/theme/theme.js